import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategorySocialMediaLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 33 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#category_social_media_large_icon_svg__a)"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#404145">
            <path d="M8.333 2a1.667 1.667 0 0 0-1.667 1.667v24a1.667 1.667 0 0 0 1.667 1.666h9.333a1 1 0 1 1 0 2H8.333a3.667 3.667 0 0 1-3.667-3.666v-24A3.667 3.667 0 0 1 8.333 0h16a3.667 3.667 0 0 1 3.666 3.667v10.666a1 1 0 1 1-2 0V3.667A1.666 1.666 0 0 0 24.333 2h-16Z"/>
            <path d="M12.848 10.792a1 1 0 0 1 1.015.027l6.666 4.166a1 1 0 0 1 0 1.696l-6.666 4.167a1 1 0 0 1-1.53-.848v-8.333a1 1 0 0 1 .515-.875Zm1.485 2.679v4.725l3.78-2.363-3.78-2.362ZM28.82 19h.002a3.844 3.844 0 0 1 3.844 3.844c0 .982-.444 2.016-.967 2.922-.54.936-1.246 1.874-1.931 2.697a35.9 35.9 0 0 1-2.686 2.872l-.048.045-.014.013-.004.004-.683-.73-.683.73h-.001l-.004-.004-.013-.013-.048-.045a34.446 34.446 0 0 1-.8-.79 35.94 35.94 0 0 1-1.886-2.082c-.686-.823-1.392-1.76-1.931-2.697-.524-.906-.968-1.94-.968-2.922h1l-1 .003a3.836 3.836 0 0 1 6.333-2.922A3.83 3.83 0 0 1 28.82 19Zm-2.487 11.667-.683.73c.384.36.981.359 1.366 0l-.683-.73Zm0-1.401.118-.12a33.934 33.934 0 0 0 1.78-1.964c.648-.777 1.275-1.617 1.735-2.415.477-.827.7-1.482.7-1.923A1.844 1.844 0 0 0 28.823 21a1.83 1.83 0 0 0-1.609.966 1 1 0 0 1-1.762.001 1.835 1.835 0 0 0-3.453.874v.003c0 .44.223 1.096.7 1.923.46.798 1.087 1.638 1.735 2.415a33.932 33.932 0 0 0 1.899 2.084Z"/>
        </g>
        <defs>
            <clipPath id="category_social_media_large_icon_svg__a">
                <path fill="#fff"
                    transform="translate(.666)"
                    d="M0 0h32v32H0z"/>
            </clipPath>
        </defs>
    </svg>
);
CategorySocialMediaLargeIcon.displayName = 'CategorySocialMediaLargeIcon';
export default CategorySocialMediaLargeIcon;
